export default {
  placeholder: {
    en: 'What is your skin type?',
  },
}
